var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"overflow-hidden"},[_vm._t("default"),_c('confirm',{ref:"confirm"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }